import React from 'react';

import currencyFormat from '../../../utils/currencyFormat';
import { OrderRealizationsItemProps } from '../types';

import './order-realizations-item.scss';

const OrderRealizationsItem: React.FC<OrderRealizationsItemProps> = ({
  title,
  count,
  sum,
}) => (
  <div className="realization-item">
    <div className="realization-item__title">{title}</div>
    <div className="realization-item__count">
      {currencyFormat(count, false)}
    </div>
    <div className="realization-item__sum">{currencyFormat(sum)}</div>
  </div>
);

export default OrderRealizationsItem;
